export function randId(prefix: string = "") {
  return (prefix ? `${prefix.replace(/\-+$/, "")}-` : "") + Math.random().toString(36).substr(2, 9);
}
